<ng-template class="theme-modal" #checkoutModal let-modal>
  <div class="modal-content quick-view-modal">
    <div class="modal-body">
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="orders overflow-auto">
        <div class="ordersheader">Order No: 001</div>
        <div class="orderlist">
          <div class="block-content">
            <ul class="mobi-cart">
              <li *ngFor="let cartItem of cartItems" class="hover-black" style="padding-top: 10px !important">
                <div class="full-width">
                  <div class="left-div">
                    <div class="img-div">
                      <img [src]="cartItem?.prodImage" />
                    </div>
                    <div>
                      <div class="semi-bold">{{ cartItem?.prodName }}</div>
                      <div class="">{{ cartItem?.uom }} - {{ cartItem?.offerPrice | currency: 'INR' : 'symbol' : '2.0-2'}}</div>
                    </div>
                  </div>
                  <div class="center-div">
                    <div class="qty-box-two">
                      <div class="qty-box">
                        <div class="input-group">
                          <span class="input-group-prepend">
                            <button
                              type="button"
                              class="quantity-left-minus"
                              data-type="minus"
                              (click)="cartdecrement(cartItem)"
                            >
                              <i class="fa fa-minus"></i>
                            </button>
                          </span>
                          <input
                            type="text"
                            name="quantity"
                            class="form-control input-number"
                            disabled
                            [value]="cartItem?.itemCount"
                          />
                          <span class="input-group-prepend">
                            <button
                              type="button"
                              class="btn quantity-right-plus"
                              data-type="plus"
                              [value]="cartItem?.itemCount"
                            (click)="cartincrement(cartItem)"
                            >
                              <i class="fa fa-plus"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right-div">
                    <span class="font-size-20">{{ cartItem?.totalPrice | currency: 'INR' : 'symbol' : '1.0-2'}}</span>
                    <i class="ti-trash"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>          
        </div>
        <div class="ordersfooter">
          <div class="row">
            <span class="font-size-12">{{ totalCartItems?.itemCount }} Items</span><br />
            <span class="font-size-20">{{ totalCartItems?.totalPrice | currency: 'INR' : 'symbol' : '1.0-2'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
